export const URL2ID = notionURL => {
  return notionURL.split(/[?#]/)[0].split("/").at(-1).split("-").at(-1)
}
export const ID2URL = notionID => {
  if(!notionID) return ""
  return `https://www.notion.so/${notionID.replace(/-/g, "")}`
  }